export enum Screens {
    UPLOAD = 'upload',
    HOME = 'home'
}

export enum ProductStatus {
    FOUND = 'FOUND',
    NOT_FOUND = 'NOT_FOUND',
    ALREADY_EXISTS = 'ALREADY_EXISTS',
    THREED_AR_LIVE = 'THREED_AR_LIVE'
}

export enum ModelStatuses {
    TO_BE_PICKED = 'TO_BE_PICKED',
    CREATION_IN_PROGRESS = 'CREATION_IN_PROGRESS',
    APPROVED = 'APPROVED',
    READY_FOR_REVIEW = 'READY_FOR_REVIEW',
    CHANGES_REQUESTED = 'CHANGES_REQUESTED'
}
export enum Roles {
    ADMIN = 'ADMIN',
    USER = 'USER',
    MODERATOR = 'MODERATOR',
    REQUESTOR = 'REQUESTOR',
    THREED_ARTIST = 'THREED_ARTIST',
    OPS_MANAGER = 'OPS_MANAGER',
    THREED_AGENCY = 'THREED_AGENCY',
    THREED_ARTIST_OR_AGENCY = 'THREED_ARTIST_OR_AGENCY',
    VENDOR = 'THREED_AGENCY'
}

export enum RequestStages {
    GENERATION = 'GENERATION',
    ASSIGNMENT = 'ASSIGNMENT',
    QUOTATION = 'QUOTATION',
    APPROVAL = 'APPROVAL',
    CREATION = 'CREATION'
}

export enum Units {
    METER = 'm',
    CENTIMETER = 'cm'
}

export enum Messages {
    HOTSPOT_CREATED = 'Created new hotspot',
    FEEDBACK_CREATED = 'Feedback submitted',
    SAVE_TO_PRODUCTION = 'save to productions',
    FEEDBACK_RESOLVED = 'Feedback Resolved.',
    FEEDBACK_DELETED = 'Feedback Deleted'
}

export enum MessageType {
    SUCCESS = 'success',
    ERROR = 'error'
}

export enum VisualQCStatus {
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    PASSED = 'PASSED'
}

export enum GoLiveStatus {
    INIT = 'INIT',
    STARTED = 'STARTED',
    FAILED = 'FAILED',
    COMPLETED = 'COMPLETED'
}

export enum PipelineStatus {
    PENDING = 'PENDING',
    STARTED = 'STARTED',
    FAILED = 'FAILED',
    COMPLETED = 'COMPLETED'
}
